import { render, staticRenderFns } from "./scoreboardHorizontal.vue?vue&type=template&id=04008cf4&scoped=true&"
import script from "./scoreboardHorizontal.vue?vue&type=script&lang=js&"
export * from "./scoreboardHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./scoreboardHorizontal.vue?vue&type=style&index=0&id=04008cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04008cf4",
  null
  
)

export default component.exports